import { createContext } from 'react';

export interface AnkiImportNotifierContextValue {
  registerStartedJob: (jobId: string) => void;
  setAnimationVisible: (visible: boolean) => void;
  isImportInProgress: boolean;
}

export const AnkiImportNotifierContext = createContext<
  AnkiImportNotifierContextValue | undefined
>(undefined);
